import { useEffect, useRef } from "react";
import { useAnimation, useInView, motion } from "framer-motion";
import clsx from "clsx";
import Container from "../../Container";
import SectionHeader from "../../SectionHeader";
import FeatureCard from "./components/FeatureCard";
import cardBlock1Picture from "../../../../../assets/images/cardPage/cardBlock1Picture.webp";
import cardBlock2Picture from "../../../../../assets/images/cardPage/cardBlock2Picture.webp";
import cardBlock3Picture from "../../../../../assets/images/cardPage/cardBlock3Picture.webp";

const analyticsWeb3 = [
  "Social + onchain data on protocols, chains, launchpads and VCs",

  "Mindshare and token insights in-feed",

  "Chain distribution and investor mapping across protocols",
];

const frames = [
  "Native apps that run directly inside X",
  "Desktop in the X surface, mobile via AGNT Mobile",
  "Progress remembered, actions continued",
];

const socials = [
  "Attention-to-earn tasks embedded directly into the feed",
  "Rewards tied to real onchain actions, not vanity metrics",
  "Campaigns to engage and retain high-intent users",
];

const infos = [
  "Zero-code studio for protocols to launch native X Mini Apps",
  "Ready-made components for launches and flows",
  "Retention mechanics baked into the same environment",
];

const aiAgents = [
  "Protocol-specific modules embedded on X pages",
  "Chat-based UX for dApp actions, alpha, and support",
  "Simplified engagement and execution UX for protocols",
];

export const CardFeatures = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <div ref={ref}>
      <Container
        animationControls={controls}
        sectionClasses=" max-lg:mt-[13vw] relative max-lg:pb-[18vw] pb-[9vw]"
      >
        <motion.div>
          <SectionHeader
            sectionHeaderClasses="mb-[1.714vw] max-lg:mb-[6.4vw]"
            title="What You’ll Unlock First"
          />
        </motion.div>

        <motion.div
          className="flex max-lg:flex-col max-lg:gap-[6.4vw] gap-[1.714vw] mb-[1.714vw] max-lg:mb-[6.4vw]"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {[
            {
              title:<>On/Off-Ramp That <br /> Lives In Your Feed</>,
              analytics:
                "Fund from crypto, cash out to fiat without leaving your crypto flow.",
              image: cardBlock1Picture,
              classes: "w-full overflow-hidden group relative",
            },
            {
              title: <>Real-World <br /> Checkout</>,
              analytics: "Apple Pay, Google Pay, and virtual card in minutes.",
              image: cardBlock2Picture,
              classes: "w-full overflow-hidden",
              imageClasses:
                "absolute bottom-0 lg:left-1/2 max-lg:-bottom-[4vw] lg:-translate-x-1/2 max-lg:w-[160vw] max-lg:left-[6vw] w-[42vw]",
            },
            {
              title: <>$ATTS <br /> Staking Tiers</>,
              analytics:
                "Reduced fees, higher limits, priority features as you stake more.",
              image: cardBlock3Picture,
              classes: "w-full overflow-hidden",
              imageClasses:
                "absolute bottom-0 lg:left-1/2 max-lg:-bottom-[4vw] lg:-translate-x-1/2 max-lg:w-[160vw] max-lg:left-[6vw] w-[42vw]",
            },
          ].map(({ title, analytics, image, classes, imageClasses }, index) => (
            <motion.div key={index} variants={cardVariants}>
              <FeatureCard cardClasses={classes}>
                <div className="flex flex-col gap-[1.39vw] max-lg:gap-[5.3vw]">
                  <img
                    src={image}
                    className="w-[26.94vw] h-auto rounded-[1vw]  max-lg:w-[87.2vw]  max-lg:h-[49.05vw]  max-lg:rounded-[3.7333vw]"
                    alt=""
                  />

                  <div className="flex flex-col gap-[0.83vw] max-lg:gap-[3.2vw] px-[0.83vw] max-lg:px-[3.2vw]">
                    <h3 className="text-[2.5vw] leading-[1.1] break-words font-luxora-regular z-20 relative text-black  max-lg:text-[6.4vw] ">
                      {title}
                    </h3>
                    <div className="text-[1.39vw] leading-[1.1] break-words text-black/60 max-lg:text-[4.2667vw]">
                      {analytics}
                    </div>
                  </div>
                </div>
              </FeatureCard>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </div>
  );
};
